# TODO: this is horrifying

module.exports =
	BEHAVIOR_TYPE_IDS:
		ON_TASK: 1
		OFF_TASK: 2
	CONTEXT_IDS:
		WHOLE_CLASS: 1
		SMALL_GROUP: 2
		INDIV: 3
	GRADE_LEVEL_IDS:
		KINDERGARTEN: 1
		PRE_K: 5
	INSTRUCTION_TYPE_IDS:
		MEANING_FOCUSED: 1
		CODE_FOCUSED: 2
		PLAY: 3
		NUMBER_OPERATIONS: 4
		ALGEBRA: 5
		GEOMETRY: 6
		APPLIED: 7
		OPERATIONS: 8
	MANAGEMENT_IDS:
		TEACHER: 1
		PEERS: 2
		ALONE: 3
	OBSERVATION_PART_TYPE_IDS:
		STUDENT: 1
		TEACHER: 2
	OBSERVATION_SUBJECT_IDS:
		NON_INSTRUCTION: 1
		LITERACY: 2
		MATH: 3
		ART: 4
		SCIENCE: 5
		SOCIAL_STUDIES: 6
		MUSIC: 7
		OTHER: 8
		MEAL_TIME: 9
		SOCIOEMOTIONAL_LEARNING: 10
		OFF_CAMERA: 11



// WEBPACK FOOTER //
// ./frontend/olos/js/lib/commonIds.coffee